export const DEPOSIT_TYPES = {
  PAYMENT: 'Pago',
  EXPENSE: 'Gasto',
  CASH_WITHDRAWAL: 'Retiro de efectivo',
  CASH_DEPOSIT: 'Ingreso de efectivo',
  BANK_WITHDRAWAL: 'Retiro bancario',
  BANK_DEPOSIT: 'Depósito bancario'
}
